<template>
  <v-container>
    <v-row align="center">
      <v-col md="5" offset-md="4">
        <v-card class="card" color="primary">
          <v-card-title> Registro de cargador </v-card-title>
          <v-card-text>
            <v-form v-model="cargadorForm">
              <v-select
                v-model="cargador.fk_idCatCalibre"
                :items="calibres"
                item-value="id"
                item-text="title"
                item-color="secondary"
                color="secondary"
                background-color="primary"
                rounded
                filled
                dense
                :rules="required"
              >
                <template v-slot:label>Calibre <span class="red--text">*</span> </template>
              </v-select>
              <v-text-field
                label="Número económico"
                v-model.number="cargador.noEconomico"
                type="number"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                :rules="required"
              >
                <template v-slot:label>Número económico <span class="red--text">*</span> </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              rounded
              color="secondary"
              class="px-4"
              :loading="loading"
              :disabled="loading || !cargadorForm"
              @click="triggerSaveCargador()"
              >Registrar cargador</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      cargadorForm: false,

      cargador: {
        noEconomico: null,
        fk_idCatCalibre: null,
      },

      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  computed: {
    ...mapGetters('calibre', {
      calibres: 'getCalibres',
    }),
  },

  methods: {
    ...mapActions('cargadores', ['saveCargador']),

    async triggerSaveCargador() {
      this.loading = true
      await this.saveCargador(this.cargador)
      this.loading = false
      this.$router.push('/armeria/dashboard')
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para registro de cargador */
.card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

/* Título */
.v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%) !important;
  color: #ffffff !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

/* Campos de entrada */
::v-deep .v-text-field .v-input__control,
::v-deep .v-select .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: 1px solid rgba(108, 92, 231, 0.2);
  transition: all 0.3s ease;
}

::v-deep .v-input--is-focused .v-input__control {
  border-color: #6c5ce7 !important;
  box-shadow: none !important;
}

::v-deep .v-text-field__slot input,
::v-deep .v-select__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-label {
  color: #b0b0b0 !important;
}

::v-deep .v-input--is-focused .v-label {
  color: #6c5ce7 !important;
}

/* Select items */
::v-deep .v-select__selections {
  color: #e0e0e0 !important;
}

/* Menu del select */
::v-deep .v-menu__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(108, 92, 231, 0.2) !important;
}

::v-deep .v-list-item__title {
  color: #e0e0e0 !important;
}

/* Asterisco rojo para campos requeridos */
.red--text {
  color: #ff5252 !important;
}

/* Mensaje de error */
::v-deep .v-messages__message {
  color: #ff5252 !important;
  font-size: 0.75rem;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

::v-deep .v-input__icon .v-icon {
  color: rgba(108, 92, 231, 0.7) !important;
}

::v-deep .v-input--is-focused .v-input__icon .v-icon {
  color: #6c5ce7 !important;
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
